/**
 * 题目类型映射工具函数
 * 统一管理所有题目类型的中文显示名称
 */

// 题目类型枚举
export enum QuestionType {
  SINGLE_CHOICE = 'singleChoice',
  MULTIPLE_CHOICE = 'multipleChoice',
  TRUE_FALSE = 'trueFalse',
  BOOLEAN = 'boolean', // 兼容旧格式
  ESSAY = 'essay',
  SHORT_ANSWER = 'shortAnswer', // 兼容旧格式
  CALCULATION = 'calculation',
  FILL_BLANK = 'fillBlank'
}

// 题目类型中文映射表
const QUESTION_TYPE_MAP: Record<string, string> = {
  singleChoice: '单选题',
  multipleChoice: '多选题',
  trueFalse: '判断题',
  boolean: '判断题', // 兼容旧格式
  essay: '简答题',
  shortAnswer: '简答题', // 兼容旧格式
  calculation: '计算题',
  fillBlank: '填空题'
}

/**
 * 获取题目类型的中文显示名称
 * @param type 题目类型
 * @returns 中文显示名称
 */
export const getQuestionTypeText = (type?: string): string => {
  if (!type) return '未知类型'
  return QUESTION_TYPE_MAP[type] || type
}

/**
 * 获取所有支持的题目类型列表
 * @returns 题目类型选项数组
 */
export const getQuestionTypeOptions = () => {
  return [
    { value: 'singleChoice', label: '单选题' },
    { value: 'multipleChoice', label: '多选题' },
    { value: 'trueFalse', label: '判断题' },
    { value: 'essay', label: '简答题' },
    { value: 'calculation', label: '计算题' },
    { value: 'fillBlank', label: '填空题' }
  ]
}

/**
 * 检查题目类型是否有效
 * @param type 题目类型
 * @returns 是否有效
 */
export const isValidQuestionType = (type: string): boolean => {
  return Object.keys(QUESTION_TYPE_MAP).includes(type)
}

/**
 * 标准化题目类型（将旧格式转换为新格式）
 * @param type 题目类型
 * @returns 标准化后的题目类型
 */
export const normalizeQuestionType = (type: string): string => {
  const typeMap: Record<string, string> = {
    boolean: 'trueFalse',
    shortAnswer: 'essay'
  }
  return typeMap[type] || type
}